export default __webpack_public_path__ + "static/media/Asset 13.bde47d52.png";